'use client';

import { defaultPage } from '@/config';
import { Box, CircularProgress, Stack, Typography } from '@mui/material';
import { useRouter } from 'next/navigation';
import { useEffect } from 'react';

export default function Page() {
	const router = useRouter();

	useEffect(() => {
		// Redirect to default page - AppWrapper/LumoraWrapper will handle auth check
		router.replace(defaultPage);
	}, [router]);

	return (
		<Box display="flex" alignItems="center" justifyContent="center" minHeight="100vh">
			<Stack spacing={1.5} alignItems="center">
				<CircularProgress color="lumoraGreenPrimary" />
				<Typography color="text.secondary">Loading...</Typography>
			</Stack>
		</Box>
	);
}
